import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Product from '@/pages/product'
import Server from '@/pages/server'
import Case from '@/pages/case'
import Jobs from '@/pages/jobs'
import About from '@/pages/about'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    }, {
      path: '/product',
      name: 'Product',
      component: Product
    }, {
      path: '/server',
      name: 'Server',
      component: Server
    }, {
      path: '/case',
      name: 'Case',
      component: Case
    }, {
      path: '/jobs',
      name: 'Jobs',
      component: Jobs
    }, {
      path: '/about',
      name: 'About',
      component: About
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js